export default __webpack_public_path__ + "static/media/floor-16.925f6a12.jpg";